module.exports = __webpack_public_path__ + "img/cub.750c91b2.svg";